import React, { useEffect, useState } from "react";
import Base from "../admin_components/Admin_Base";
import authAxios from "../Auth/useAxios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import { CircularProgress, Breadcrumbs } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Link from "@mui/material/Link";
import dayjs from "dayjs";

const Activities = () => {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTracks = async () => {
      try {
        const response = await authAxios.get(`${ADMIN_API_BASE_URL}/main/admin/all-tracks`);
        if (Array.isArray(response.data)) {
          setTracks(response.data);
        } else {
          console.error("Unexpected API response:", response.data);
          setError("Unexpected response format");
        }
      } catch (err) {
        console.error("Error fetching tracks:", err);
        setError("Failed to load activity logs");
      } finally {
        setLoading(false);
      }
    };
    fetchTracks();
  }, []);

  return (
    <Base>
      <div
        className="pt-3 mt-5 res_container"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          className="admin_navigation"
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="none"
            key="2"
            color="inherit"
            href="/admin/activities"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Activities
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold main_heading">Admin Activity Logs</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "94%" }} />
      </div>

      <div className="container mt-4">
        {loading ? (
          <div className="text-center mt-5">
            <CircularProgress />
            <p className="mt-2">Loading activities...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger text-center">{error}</div>
        ) : tracks.length === 0 ? (
          <div className="alert alert-info text-center">No activity logs found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-hover shadow-sm">
              <thead className="table-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">User Name</th>
                  <th scope="col">Role</th>
                  <th scope="col">Task</th>
                  <th scope="col">Created At</th>
                </tr>
              </thead>
              <tbody>
                {tracks.map((track, index) => (
                  <tr key={track.id}>
                    <td>{index + 1}</td>
                    <td>{track.name}</td>
                    <td>{track.role}</td>
                    <td>{track.task}</td>
                    <td>
                      {dayjs(track.createdAt).format("DD MMM YYYY, hh:mm A")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Base>
  );
};

export default Activities;
